import {setLoading, useMaterialUIController} from "../../Context/mui";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDTableCell from "../../Components/MDTable/MDTableCell";
import {Table} from "reactstrap";
import MDBox from "../../Components/MDBox";
import Paper from "@mui/material/Paper";
import MDTableRow from "../../Components/MDTable/MDTableRow";
import React, {forwardRef, useEffect, useState} from "react";
import MDButton from "../../Components/MDButton";
import {
    Autocomplete,
    Grid, Slide,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField
} from "@mui/material";
import MDTypography from "../../Components/MDTypography";
import MDInput from "../../Components/MDInput";
import MDSelect from "../../Components/MDSelect";
import MDDate from "../../Components/MDDate";
import {ErrorToaast, InfoToaast} from "../../utils/toast/Toast";
import {v4 as uuid} from "uuid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Cookies from "js-cookie";
import {NoskheModel} from "../../Api/Model/NoskheModel";
import {ReactComponent as Moshahede} from '../../Asset/images/icons/lets-icons_view.svg'
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import {CurrentUser} from "../../utils/Hooks/currentUser";
import {UserModel} from "../../Api/Model/UserModel";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import {User} from "oidc-client";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const initalSearchParams = {
    Username: "",
    Name: "",
    Role: "",
    Vaziat: "",
    AzSabt: "",
    TaSabt: "",
};
export default function UsersPage() {
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [counter, setCounter] = useState(0)
    const [controller, dispatch] = useMaterialUIController();
    const [changePassword, setChangePassword] = useState({open: false, model: {id: 0, pass: ""}});
    const [onvanmsg, setOnvanMsg] = React.useState("");

    const [searchParams, setSearchParams] = useState(initalSearchParams);
    let UserApi = new UserModel(Cookies.get("cst") ?? "");
    const {loading} = controller;
    const [rows, setRows] = useState({
        content: [],
        pageSize: 0,
        totalPages: 0,
    });

    const handleChangePage = (event, newPage) => {
        setPageNumber(newPage + 1);
    };
    const handleChangeRowsPerPage = (
        event
    ) => {
        setPageSize(+event.target.value);
        setPageNumber(1);
    };

    function defaultLabelDisplayedRows({from, to, count}) {
        return `${from}–${to} از ${
            count !== -1 ? count : `بیشتر از ${to}`
        }`;
    }

    function handleSearch() {
        const {Username, Role, AzSabt, TaSabt, Vaziat, Name} = searchParams;
        if (
            Username === "" &&
            Name === "" &&
            Role === "" &&
            AzSabt === "" &&
            Vaziat === "" &&
            TaSabt === ""
        ) {
            return setCounter((c) => c + 1);
        } else {
            setLoading(dispatch, true);
            UserApi
                .GetUserSearch(
                    searchParams.Username,
                    searchParams.Name,
                    searchParams.Vaziat,
                    searchParams.Role,
                    searchParams.AzSabt,
                    searchParams.TaSabt,
                )
                .then((r) => {
                    setRows({content: r.data.data, pageSize: 0, totalPages: 0});
                    setLoading(dispatch, false);
                })
                .catch((r) => {
                    setLoading(dispatch, false);
                    ErrorToaast("دریافت اطلاعات با مشکل مواجه شد");
                });
        }

    }

    useEffect(() => {
        setLoading(dispatch, true);
        UserApi
            .getUsersPaginate(pageNumber, pageSize)
            .then((r) => {
                setRows(r.data.data);
            }).catch
        (r => {
            if (r?.status == 404) {
                setLoading(dispatch, false)

                return
            }
            ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
            setLoading(dispatch, false)

        })
            .finally(() => {
                setLoading(dispatch, false);
            });


    }, [pageNumber, pageSize, counter]);

    function handleChangePassword(id) {
        setOnvanMsg("")
        setChangePassword({open: true, model: {id: id, pass: ""}})
    }

    function handleClosePassword() {
        setOnvanMsg("")
        setChangePassword({open: false, model: {id: 0, pass: ""}})
    }


    function handleSendPassword() {
        if (onvanmsg!== "") {
            setLoading(dispatch, true)
            UserApi.ChangePassword(changePassword.model.id, onvanmsg).then(r => {
                setLoading(dispatch, false)
                setChangePassword({open: false, model: {id: 0, pass: ""}})
                setOnvanMsg("")
                setCounter(c => c + 1)
                InfoToaast("کلمه عبور با موفقیت تغییر کرد")
            }).catch(r => {
                setOnvanMsg("")
                setLoading(dispatch, false)
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
            })
        } else {
            ErrorToaast("لطفا کلمه عبور را وارد کنید")
        }
    }


    function handleChangeStatus(id) {
        setLoading(dispatch, true)
        UserApi.ChangeUserStatus(id).then(r => {
            setLoading(dispatch, false)
            setCounter(c => c + 1)
        }).catch(r => {
            setLoading(dispatch, false)
            ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
        })
    }



    return (
        <DashboardLayout>
            <DashboardNavbar name={"کاربران"}>
                کاربران
            </DashboardNavbar>
            <MDBox py={3} bgColor={"#e8e8e8"} p={2} mb={2} borderRadius={20}>
                <MDTypography fontSize={14}>جستجو در فرم ها</MDTypography>
                <Grid
                    container
                    mb={2}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                >
                    <Grid item container xs={12} md={6} lg={6} alignItems="center">
                        <Grid item xs={2} textAlign="center">
                            <MDTypography fontSize={14}>نام کاربری</MDTypography>
                        </Grid>
                        <Grid item xs={8} my={1}>
                            <MDInput
                                size={"small"}
                                name="Username"
                                label={"نام کاربری"}
                                fullWidth
                                onChange={(e) =>
                                    setSearchParams((p) => ({...p, Username: e.target.value}))
                                }
                                value={searchParams.Username}
                                focused
                                autoComplete="off"
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} md={6} lg={6} alignItems="center">
                        <Grid item xs={2} textAlign="center">
                            <MDTypography fontSize={14}>نام و نام خانوادگی</MDTypography>
                        </Grid>
                        <Grid item xs={8} my={1}>
                            <MDInput
                                size={"small"}
                                name="Name"
                                label={"نام و نام خانوادگی"}
                                fullWidth
                                onChange={(e) =>
                                    setSearchParams((p) => ({...p, Name: e.target.value}))
                                }
                                value={searchParams.Name}
                                focused
                                autoComplete="off"
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} md={6} lg={6} alignItems="center">
                        <Grid item xs={2} textAlign="center">
                            <MDTypography fontSize={14}>وضعیت</MDTypography>
                        </Grid>
                        <Grid item xs={8} my={1}>
                            <MDSelect
                                id="Vaziat"
                                name="Vaziat"
                                onChange={(r) => {
                                    setSearchParams((p) => ({
                                        ...p,
                                        Vaziat: r,
                                    }))
                                }}


                                value={searchParams.Vaziat}

                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "100%",}}
                                label={"وضعیت"}>
                                <option value={0}>همه</option>
                                <option value={1}>فعال</option>
                                <option value={2}>غیر فعال</option>


                            </MDSelect>

                        </Grid>
                    </Grid>
                    <Grid item container xs={12} md={6} lg={6} alignItems="center">
                        <Grid item xs={2} textAlign="center">
                            <MDTypography fontSize={14}>{"نقش"}</MDTypography>
                        </Grid>
                        <Grid item xs={8} my={1}>
                            <MDSelect
                                id="Role"
                                name="Role"
                                onChange={(r) => {
                                    setSearchParams((p) => ({
                                        ...p,
                                        Role: r,
                                    }))
                                }}


                                value={searchParams.Role}

                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "100%",}}
                                label={"نقش "}>
                                <option value={"Admin"}>ادمین</option>
                                <option value={"Pezeshk"}>پزشک</option>
                                <option value={"Student"}>دانش آموز</option>
                                <option value={"Parent"}>والدین</option>
                                <option value={"Morabi"}>مربی</option>


                            </MDSelect>

                        </Grid>
                    </Grid>

                    <Grid item container xs={12} md={6} lg={6} alignItems="center">
                        <Grid item xs={2} textAlign="center">
                            <MDTypography fontSize={14}>از تاریخ</MDTypography>
                        </Grid>
                        <Grid item xs={8} my={1}>
                            <MDDate
                                name="FormDate"

                                onChange={(e) =>
                                    setSearchParams((p) => ({
                                        ...p,
                                        AzSabt: e,
                                    }))
                                }
                                defaultValue={searchParams.AzSabt}
                                label={"تاریخ "}
                                sx={{width: "100%"}}
                                portal
                                fullWidth
                                disabled={loading}
                            />

                        </Grid>
                    </Grid>
                    <Grid item container xs={12} md={6} lg={6} alignItems="center">
                        <Grid item xs={2} textAlign="center">
                            <MDTypography fontSize={14}>تا تاریخ</MDTypography>
                        </Grid>
                        <Grid item xs={8} my={1}>
                            <MDDate
                                name="FormDate"

                                onChange={(e) =>
                                    setSearchParams((p) => ({
                                        ...p,
                                        TaSabt: e,
                                    }))
                                }
                                defaultValue={searchParams.TaSabt}
                                label={"تاریخ "}
                                sx={{width: "100%"}}
                                portal
                                fullWidth
                                disabled={loading}
                            />

                        </Grid>
                    </Grid>
                </Grid>
                <MDBox>
                    <MDButton variant="text" color="primary" onClick={handleSearch}>
                        {"جستجو"}
                    </MDButton>
                    <MDButton
                        variant="text"
                        color="secondary"
                        onClick={() => {
                            setSearchParams(initalSearchParams);
                            setCounter((c) => c + 1);
                        }}
                    >
                        {"انصراف"}
                    </MDButton>
                </MDBox>
            </MDBox>
            <MDBox py={3} bgColor="#fff" p={2} mb={2} flex={1} borderRadius={2}>
                <Grid container flexDirection={"column"}>
                    <Grid item sx={{width: "100%"}}>
                        <TableContainer component={Paper} sx={{width: "100%"}}>
                            <Table sx={{minWidth: 700}} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            نام کاربری
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            نام و نام خانوادگی
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            وضعیت
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            تاریخ ثبت نام
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            تاریخ آخرین آنلاین
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            نقش
                                        </MDTableCell>

                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            عملیات
                                        </MDTableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows?.content.length < 1 && (
                                        <MDTableRow
                                            sx={{
                                                "&:last-child td, &:last-child th": {border: 0},
                                            }}
                                        >
                                            <MDTableCell colSpan={9} align="right">
                                                بدون اطلاعات
                                            </MDTableCell>
                                        </MDTableRow>
                                    )}
                                    {rows?.content?.map((r) => {
                                        return (
                                            <MDTableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={uuid()}
                                            >
                                                <MDTableCell align={"center"}>
                                                    {r?.userName}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {r?.name} {r?.lastName}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {r?.isActive === "True" ? "فعال" : "غیر فعال"}
                                                </MDTableCell>

                                                <MDTableCell align={"center"}>
                                                    {new Date(r?.created).toLocaleString('fa-IR')}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {new Date(r?.lastLoginDate).toLocaleString('fa-IR')}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {r?.role === "Student" && "دانش آموز"}
                                                    {r?.role === "Pezeshk" && "پزشک"}
                                                    {r?.role === "Morabi" && "مربی"}
                                                    {r?.role === "Parent" && "والدین"}
                                                    {r?.role === "Admin" && "ادمین"}
                                                </MDTableCell>


                                                <MDTableCell align={"center"}>
                                                    <Tooltip title="تغیر رمز عبور">
                                                        <IconButton onClick={() => handleChangePassword(r?.id)}>
                                                            <LockOpenIcon/>
                                                        </IconButton>
                                                    </Tooltip>

                                                    <Tooltip title="تغیر وضعیت">
                                                        <IconButton onClick={() => handleChangeStatus(r?.id)}>
                                                            <AutorenewIcon/>
                                                        </IconButton>
                                                    </Tooltip>

                                                </MDTableCell>

                                            </MDTableRow>


                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {rows?.content.length > 0 && (
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={rows.totalPages}
                                rowsPerPage={pageSize}
                                page={pageNumber - 1}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelDisplayedRows={defaultLabelDisplayedRows}
                                labelRowsPerPage={<>تعداد در هر صفحه</>}
                            />
                        )}
                    </Grid>
                </Grid>

            </MDBox>

            {changePassword.open &&
                <Dialog
                    open={changePassword.open}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleClosePassword}
                    fullWidth
                    aria-describedby="alert-dialog-slide-description1"
                >
                    <DialogTitle>رمز عبور</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description1" sx={{fontSize: "26px"}}>

                            <Grid container gap={5}>
                                <Grid container item>
                                    <MDInput
                                        id="onvanmsg"
                                        name="onvanmsg"
                                        value={onvanmsg}
                                     

                                        onChange={(r) => setOnvanMsg(r.target.value)}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        w={{xs: "100%"}}
                                        fullWidth
                                        label={"رمز عبور"}/>

                                </Grid>

                            </Grid>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <MDButton variant={"outlined"} color={"warning"} size={"large"}
                                  onClick={handleSendPassword}>ارسال</MDButton>
                        <MDButton variant={"outlined"} color={"info"} size={"large"}
                                  onClick={handleClosePassword}>بازگشت</MDButton>
                    </DialogActions>

                </Dialog>
            }
        </DashboardLayout>

    )
}